import { setCookie, getCookie } from '../components/modules/cookie';

export default function () {
  const cookiePopupEl = document.querySelector('.cookie-popup');
  const buttonEl = document.querySelector('.cookie-popup__button');

  const cookieName = '_cookie_popup';

  function cookieBarRemove() {
    cookiePopupEl.remove();
  }

  function cookieBarShow() {
    if (!getCookie(cookieName)) {
      cookiePopupEl.style.display = 'flex';
      setTimeout(() => {
        cookiePopupEl.classList.add('cookie-popup--active');
        cookiePopupEl.style.opacity = 1;
      }, 300);
    } else {
      cookieBarRemove();
    }
  }

  function cookieBarHide() {
    setCookie(cookieName, 1, 3);
    cookiePopupEl.addEventListener('transitionend', () => {
      cookieBarRemove();
    }, { once: true });

    cookiePopupEl.style.opacity = '';
  }

  if (cookiePopupEl) {
    window.addEventListener('load', () => {
      setTimeout(() => { cookieBarShow(); }, 3000);

      buttonEl.addEventListener('click', () => {
        cookieBarHide();
      }, { once: true });
    }, { once: true });
  }
}
